import { yupResolver } from '@hookform/resolvers/yup';
import { Groups } from '@mui/icons-material';
import { Box, DialogActions, DialogContent, Grid } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { FieldValues, FormProvider, useForm } from 'react-hook-form';
import { IClientSettings } from 'wisestep-api';
import {
  WsButton,
  WsDialog,
  WsTypography,
  WsTypoVariants,
  WsColors,
  Item,
  ControlledTextInput,
  WsEditor,
  useWsEditor,
} from 'wisestep-base';
import { object, string } from 'yup';

interface IBusinessUnitProps {
  openDialog: boolean;
  closeDialog(): void;
  onInput: (data: FieldValues) => void;
  businessUnit?: IClientSettings;
  dataCallback(data: IClientSettings): void;
  onEdit: number;
}

const validationSchema = {
  name: string().required('Please enter business unit'),
};

const AddBusinessUnitDialog = ({
  openDialog,
  closeDialog,
  onInput,
  businessUnit,
  dataCallback,
  onEdit,
}: IBusinessUnitProps) => {
  const formOptions = {
    resolver: yupResolver(object().shape(validationSchema)),
    defaultValues: {
      name: businessUnit?.name ?? '',
      description: isEmpty(businessUnit?.description) ? '' : businessUnit?.description,
    },
  };
  const methods = useForm(formOptions);
  const { setValue, reset } = methods;
  const onDescUpdate = (args: string | null) => {
    setValue('description', args ? args : '');
  };
  const editor = useWsEditor(businessUnit?.description ?? '', onDescUpdate);

  const saveName = (data) => {
    closeDialog();
    onInput(data);
    reset();
  };

  const onUpdate = (data) => {
    data.id = businessUnit?.id;
    data.active = true;
    dataCallback(data);
    reset();
  };

  return (
    <FormProvider {...methods}>
      <WsDialog openDialog={openDialog} size="medium">
        <Grid className="your-dialog">
          <Grid container flexDirection="column">
            <DialogContent>
              <Item sx={{ pl: '45%', pr: '45%' }}>
                <Groups sx={{ color: WsColors.TheBlues400, fontSize: '60px' }} />
              </Item>
              <Item sx={{ margin: 'auto', py: 0, my: 0 }}>
                <WsTypography bold variant={WsTypoVariants.TITLE}>
                  Enter a name for your Business Unit
                </WsTypography>
              </Item>

              <Item sx={{ margin: 'auto' }}>
                <ControlledTextInput
                  name="name"
                  placeholder="Enter Business Unit Name"
                  required
                  fullWidth
                />
              </Item>

              <Item sx={{ margin: 'auto', py: 0, my: 0 }}>
                <WsTypography bold variant={WsTypoVariants.TITLE}>
                  Description
                </WsTypography>
              </Item>
              <Item>
                <Box minHeight={100} border={1} borderColor={'gray'}>
                  <WsEditor editor={editor} resizable={true} editorHeight={172}></WsEditor>
                </Box>
              </Item>
            </DialogContent>
            <DialogActions>
              <WsButton size="large" variant="outlined" onClick={closeDialog}>
                Cancel
              </WsButton>
              {onEdit == 1 ? (
                <WsButton size="large" variant="contained" onClick={methods.handleSubmit(onUpdate)}>
                  Update
                </WsButton>
              ) : (
                <WsButton size="large" variant="contained" onClick={methods.handleSubmit(saveName)}>
                  Save
                </WsButton>
              )}
            </DialogActions>
          </Grid>
        </Grid>
      </WsDialog>
    </FormProvider>
  );
};
export default AddBusinessUnitDialog;
